/**
 * Feb 28, 2026 · Export Dispatch History wrapper.
 * Thin shim over `DispatchHistory` that locks the source to ESO so the
 * Exports module has a dedicated entry point without duplicating the shell.
 */
import DispatchHistory from "@/pages/DispatchHistory";

export default function ExportDispatchHistory() {
  return (
    <DispatchHistory
      defaultSource="ESO"
      lockSource
      title="Export Order Dispatch History"
      subtitle="Chronological shipment feed per line item · aggregated by EPL / Shipping Bill · PDF export for the buyer."
      testIdPrefix="eso-dispatch-history"
    />
  );
}
